import axios from 'axios';

export const API_BASE_URL =
  process.env.REACT_APP_API_URL?.trim() || 'http://127.0.0.1:8000/api';

export const API_ORIGIN = API_BASE_URL.replace(/\/api\/?$/, '');

export const TOKEN_STORAGE_KEY = 'menu_auth_token';

const axiosClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    Accept: 'application/json',
  },
});

// Attach auth token only to protected requests.
axiosClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem(TOKEN_STORAGE_KEY);
    const requestUrl = String(config.url || '');
    const isPublicRequest = requestUrl.startsWith('/public/');

    if (token && !isPublicRequest) {
      config.headers.Authorization = `Bearer ${token}`;
    } else if (isPublicRequest && config.headers) {
      delete config.headers.Authorization;
    }

    console.log('API request:', {
      method: config.method?.toUpperCase(),
      url: `${config.baseURL}${config.url}`,
      params: config.params || null,
      isPublicRequest,
      authenticated: Boolean(config.headers?.Authorization),
    });

    return config;
  },
  (error) => Promise.reject(error),
);

// Normalize API errors.
axiosClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const response = error.response;

    console.error('API error:', {
      message: error.message,
      url: error.config
        ? `${error.config.baseURL}${error.config.url}`
        : 'Unknown URL',
      status: response?.status || null,
      data: response?.data || null,
    });

    if (response?.status === 401) {
      localStorage.removeItem(TOKEN_STORAGE_KEY);
    }

    return Promise.reject(error);
  },
);

export const getApiErrorMessage = (error) => {
  if (!error?.response) {
    return `Unable to connect to the server. Tried: ${
      error?.config?.baseURL || API_BASE_URL
    }${error?.config?.url || ''}`;
  }

  return (
    error.response?.data?.message ||
    error.message ||
    'Une erreur est survenue.'
  );
};

export const getApiValidationErrors = (error) => {
  return error?.response?.data?.errors || {};
};

export default axiosClient;